import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorPanelService } from '../services/error-panel.service';
import { environment } from '../../environments/environment';
import { UploadCompleteResponse } from '../models/ai-model';

@Injectable({
  providedIn: 'root',
})
export class AppointmentsService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  addHeader(): HttpHeaders {
    const token = sessionStorage.getItem('psicogeniusAccessToken');
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }
  notifyUploadComplete(
    appointmentId: string
  ): Observable<UploadCompleteResponse> {
    const endpoint =
      this.apiUrl + '/appointments/' + appointmentId + '/upload-complete';
    const headers = this.addHeader();
    return this.http.post<UploadCompleteResponse>(endpoint, {}, { headers });
  }

  getSignedUrl(appointmentId: string, contentType: string): Observable<string> {
    const endpoint =
      this.apiUrl + '/appointments/' + appointmentId + '/upload-url';
    const headers = this.addHeader();
    return this.http.get<string>(endpoint, {
      headers,
      params: { content_type: contentType },
    });
  }
}
